import { Link } from "react-router-dom";
import { contactEmail, navItems, siteDescription, siteName, siteTagline } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                15
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                {siteName}
              </span>
            </div>
            <p className="label-caps mt-4 text-[11px] text-accent-700">{siteTagline}</p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {siteDescription}
            </p>
            <p className="mt-5 text-sm text-foreground-600">
              线索与联系邮箱：
              <a
                href={`mailto:${contactEmail}`}
                className="ml-1 font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
              >
                {contactEmail}
              </a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-foreground-900">栏目导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-bold text-foreground-900">主题档案</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/topic/${cat.slug}`}
                    className="inline-block rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-mail-line", label: "邮件订阅" },
                { icon: "ri-rss-line", label: "内容更新" },
              ].map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  aria-label={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600"
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true" />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteName} · 内容仅基于公开信息进行结构梳理与逻辑分析</p>
          <p>本站案例均做匿名化处理，不对任何具体个人或机构作出事实指控</p>
        </div>
      </div>
    </footer>
  );
}